import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { of, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from './users.model';
import {environment} from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class UsersService {
  apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api.old_url;
  }

  getUsers(): Observable<Array<User>> {

    const token = '1|PLbS89X1TrIK8ljtDRXqz9hCW7NsCDhediCKbjaZ560eae22';
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };

    return this.http
      .get<{ data: User[] }>(
        this.apiUrl + '/api/v1/users',
        httpOptions
      )
      .pipe(
        tap(response => {
          console.log('Response:', response) // Log the response
        }),
        map((users) => users.data || [])
      );
  }
}
